import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import TMHBanner from "../../components/TMHBanner/TMHBanner"
import TMHFormWrapper from "../../components/TMHForm/TMHFormWrapper"
import TMHFormBase from "../../components/TMHForm/TMHFormBase"
import TMHFormInput from "../../components/TMHForm/TMHFormInput"
import Separator from "../../components/Separator/Separator"
import TMHLoader from "../../components/TMHLoader/TMHLoader"
import "./LogInPage.css"
import "./LoginPage.scss"
import validator from 'validator'
import config from "../../config.json"
import useAuth from "../../core/Authentication/useAuth"
import { useParams } from 'react-router-dom'
import { useTitle } from 'react-use'
import ReactGA from "react-ga4"
import { Modal } from "react-bootstrap"
import rokuRemoteIcon from "./images/roku-remote-icon.png"
import starIcon from "./images/star-icon.png"
import qrImg from "./images/qr-img-updated.png"

export default function LogInPage() {
    useTitle("Login - The Movie House TV")
    let { message } = useParams();
    var isShowPopup = false
    if (message === "Reset successful") {
        message = "Reset successful!"
    }
    else {
        if (message === "install-roku-remote-app") {
            isShowPopup = true
        }
        message = ""
    }

    useEffect(() => {
        ReactGA.send("pageview")

        if (isShowPopup) {
            if (/(android)/i.test(navigator.userAgent)) {
                setShowInstallRokuModalAndroid(true)
            } else {
                setShowInstallRokuModalDesktop(true)
            }
        }
    }, [isShowPopup])

    const auth = useAuth()
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [emailAddress, setEmailAddress] = useState("")
    const [password, setPassword] = useState("");
    const [errorText, setErrorText] = useState("")
    const [successText, setSuccessText] = useState(message)
    const [showInstallRokuModalDesktop, setShowInstallRokuModalDesktop] = useState(false)
    const [showInstallRokuModalAndroid, setShowInstallRokuModalAndroid] = useState(false)

    async function handleSubmit(event) {
        event.preventDefault();
        setSuccessText("")

        if (!validator.isEmail(emailAddress)) {
            setErrorText("Invalid email address!")
            return
        }

        if (password === "") {
            setErrorText("Password cannot be empty!")
            return
        }

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Cache-Control", "no-cache");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({
                "username": emailAddress,
                "password": password
            }),
        }

        setIsLoading(true)

        fetch(config.baseUrl + "login", requestOptions)
            .then((response) => {
                return new Promise((resolve) => response.json()
                    .then((json) => resolve({
                        status: response.status,
                        ok: response.ok,
                        json,
                    })))
            }).then(
                (result) => {
                    let json = result.json
                    if (result.ok) {
                        auth.login({
                            pin: json.pin,
                            username: json.username,
                            user_id: json.user_id,
                            token: json.token
                        })
                        navigate("/profile");
                    }
                    else {
                        setErrorText(json.message)
                        setIsLoading(false)
                    }
                },
                (error) => {
                    console.error(error)
                    setErrorText(error.toString())
                    setIsLoading(false)
                }
            )
    }

    return (
        <TMHBanner isLogged={false}>
            <TMHFormWrapper>
                <TMHFormBase onSubmit={handleSubmit} method="POST">
                    <div className="login-page-warring-text">New release movies are for members only!</div>
                    <Separator />
                    <div className="login-page-title">
                        <span>Sign into your account today and check</span>
                        <span className="red-color"> your progress</span>
                    </div>
                    <div className="red-color">{errorText}</div>
                    <div className="login-page-message-text">{successText}</div>
                    <TMHFormInput
                        type="text"
                        placeholder="Email"
                        value={emailAddress}
                        onChange={({ target }) => setEmailAddress(target.value)}
                    />
                    <TMHFormInput
                        type="password"
                        placeholder="Password"
                        autoComplete="off"
                        value={password}
                        onChange={({ target }) => setPassword(target.value)}
                    />
                    <div className="login-page-button-block">
                        {/* <a href="/#/register" className="login-page-button-sign-up">Don't have Account?</a> */}
                        <a href="/tmh/#/forgot-password" target="_blank" className="login-page-button-forgot-password">Forgot Password?</a>
                    </div>
                    <button type="submit" className="login-page-join-now-button">
                        <div className="login-page-join-now-text">Login</div>
                    </button>
                </TMHFormBase>
                {isLoading && <TMHLoader />}
            </TMHFormWrapper>
            <Modal
                show={showInstallRokuModalAndroid}
                onHide={() => setShowInstallRokuModalAndroid(false)}
                size="lg"
                centered
            >
                <Modal.Body className="modal-body-dark-3-login">
                    <div className="close-button" onClick={() => setShowInstallRokuModalAndroid(false)} />
                    <img className="roku-remote-icon" alt="roku-remote-icon" src={rokuRemoteIcon} />
                    <div className="remote-app-text">Simple <b>Roku<br/>Remote +</b></div>
                    <div className="block-text-1">
                        <p>
                            Download and install the Roku Remote + for your Android device to control any app on your Roku device just as easily as your Roku remote.
                        </p>
                    </div>
                    <div className="block-text-2">
                        <p>1. Install via google play</p>
                        <p>2. Give us a great rating <img className="star-icon" src={starIcon} alt="star"></img><img className="star-icon" src={starIcon} alt="star"></img><img className="star-icon" src={starIcon} alt="star"></img><img className="star-icon" src={starIcon} alt="star"></img><img className="star-icon" src={starIcon} alt="star"></img></p>
                        <p>3. We'll verify and add your 25%</p>
                    </div>

                    <a href="https://play.google.com/store/apps/details?id=com.rokuremote" target="_blank" rel="noreferrer"><button className="send-button">INSTALL ON GOOGLE PLAY NOW</button></a>

                </Modal.Body>
            </Modal>

            <Modal
                show={showInstallRokuModalDesktop}
                onHide={() => setShowInstallRokuModalDesktop(false)}
                size="lg"
                centered
            >
                <Modal.Body className="modal-body-dark-3-login">
                    <div className="close-button" onClick={() => setShowInstallRokuModalDesktop(false)} />
                    <img className="roku-remote-icon" alt="roku-remote-icon" src={rokuRemoteIcon} />
                    <div className="remote-app-text">Simple <b>Roku<br/>Remote +</b></div>
                    <div className="block-text-1">
                        <p>
                        Available on <b>Android devices only.</b> Download on your device now by scanning the below code.</p>
                    </div>
                    <img className="qr-img" alt="qr" src={qrImg} />
                </Modal.Body>
            </Modal>
        </TMHBanner>
    )
}
